/**
 * @fileoverview gRPC-Web generated client stub for order_endpoint
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v2.0.2
// 	protoc              v6.32.1
// source: order.proto


/* eslint-disable */
// @ts-nocheck


import * as grpcWeb from 'grpc-web';

import * as order_pb from './order_pb'; // proto import: "order.proto"


export class OrderEndpointClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: any; };

  constructor (hostname: string,
               credentials?: null | { [index: string]: string; },
               options?: null | { [index: string]: any; }) {
    if (!options) options = {};
    if (!credentials) credentials = {};
    options['format'] = 'binary';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname.replace(/\/+$/, '');
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodDescriptorDirectExchange = new grpcWeb.MethodDescriptor(
    '/order_endpoint.OrderEndpoint/DirectExchange',
    grpcWeb.MethodType.UNARY,
    order_pb.DirectExchangeRequest,
    order_pb.DirectExchangeResponse,
    (request: order_pb.DirectExchangeRequest) => {
      return request.serializeBinary();
    },
    order_pb.DirectExchangeResponse.deserializeBinary
  );

  directExchange(
    request: order_pb.DirectExchangeRequest,
    metadata?: grpcWeb.Metadata | null): Promise<order_pb.DirectExchangeResponse>;

  directExchange(
    request: order_pb.DirectExchangeRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: order_pb.DirectExchangeResponse) => void): grpcWeb.ClientReadableStream<order_pb.DirectExchangeResponse>;

  directExchange(
    request: order_pb.DirectExchangeRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: order_pb.DirectExchangeResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/order_endpoint.OrderEndpoint/DirectExchange',
        request,
        metadata || {},
        this.methodDescriptorDirectExchange,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/order_endpoint.OrderEndpoint/DirectExchange',
    request,
    metadata || {},
    this.methodDescriptorDirectExchange);
  }

  methodDescriptorExternalExchange = new grpcWeb.MethodDescriptor(
    '/order_endpoint.OrderEndpoint/ExternalExchange',
    grpcWeb.MethodType.UNARY,
    order_pb.ExternalExchangeRequest,
    order_pb.ExternalExchangeResponse,
    (request: order_pb.ExternalExchangeRequest) => {
      return request.serializeBinary();
    },
    order_pb.ExternalExchangeResponse.deserializeBinary
  );

  externalExchange(
    request: order_pb.ExternalExchangeRequest,
    metadata?: grpcWeb.Metadata | null): Promise<order_pb.ExternalExchangeResponse>;

  externalExchange(
    request: order_pb.ExternalExchangeRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: order_pb.ExternalExchangeResponse) => void): grpcWeb.ClientReadableStream<order_pb.ExternalExchangeResponse>;

  externalExchange(
    request: order_pb.ExternalExchangeRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: order_pb.ExternalExchangeResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/order_endpoint.OrderEndpoint/ExternalExchange',
        request,
        metadata || {},
        this.methodDescriptorExternalExchange,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/order_endpoint.OrderEndpoint/ExternalExchange',
    request,
    metadata || {},
    this.methodDescriptorExternalExchange);
  }

  methodDescriptorPlaceOrder = new grpcWeb.MethodDescriptor(
    '/order_endpoint.OrderEndpoint/PlaceOrder',
    grpcWeb.MethodType.UNARY,
    order_pb.PlaceOrderRequest,
    order_pb.PlaceOrderResponse,
    (request: order_pb.PlaceOrderRequest) => {
      return request.serializeBinary();
    },
    order_pb.PlaceOrderResponse.deserializeBinary
  );

  placeOrder(
    request: order_pb.PlaceOrderRequest,
    metadata?: grpcWeb.Metadata | null): Promise<order_pb.PlaceOrderResponse>;

  placeOrder(
    request: order_pb.PlaceOrderRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: order_pb.PlaceOrderResponse) => void): grpcWeb.ClientReadableStream<order_pb.PlaceOrderResponse>;

  placeOrder(
    request: order_pb.PlaceOrderRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: order_pb.PlaceOrderResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/order_endpoint.OrderEndpoint/PlaceOrder',
        request,
        metadata || {},
        this.methodDescriptorPlaceOrder,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/order_endpoint.OrderEndpoint/PlaceOrder',
    request,
    metadata || {},
    this.methodDescriptorPlaceOrder);
  }

  methodDescriptorGetOrders = new grpcWeb.MethodDescriptor(
    '/order_endpoint.OrderEndpoint/GetOrders',
    grpcWeb.MethodType.UNARY,
    order_pb.GetOrdersRequest,
    order_pb.GetOrdersResponse,
    (request: order_pb.GetOrdersRequest) => {
      return request.serializeBinary();
    },
    order_pb.GetOrdersResponse.deserializeBinary
  );

  getOrders(
    request: order_pb.GetOrdersRequest,
    metadata?: grpcWeb.Metadata | null): Promise<order_pb.GetOrdersResponse>;

  getOrders(
    request: order_pb.GetOrdersRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: order_pb.GetOrdersResponse) => void): grpcWeb.ClientReadableStream<order_pb.GetOrdersResponse>;

  getOrders(
    request: order_pb.GetOrdersRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: order_pb.GetOrdersResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/order_endpoint.OrderEndpoint/GetOrders',
        request,
        metadata || {},
        this.methodDescriptorGetOrders,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/order_endpoint.OrderEndpoint/GetOrders',
    request,
    metadata || {},
    this.methodDescriptorGetOrders);
  }

  methodDescriptorCancel = new grpcWeb.MethodDescriptor(
    '/order_endpoint.OrderEndpoint/Cancel',
    grpcWeb.MethodType.UNARY,
    order_pb.CancelRequest,
    order_pb.CancelResponse,
    (request: order_pb.CancelRequest) => {
      return request.serializeBinary();
    },
    order_pb.CancelResponse.deserializeBinary
  );

  cancel(
    request: order_pb.CancelRequest,
    metadata?: grpcWeb.Metadata | null): Promise<order_pb.CancelResponse>;

  cancel(
    request: order_pb.CancelRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: order_pb.CancelResponse) => void): grpcWeb.ClientReadableStream<order_pb.CancelResponse>;

  cancel(
    request: order_pb.CancelRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: order_pb.CancelResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/order_endpoint.OrderEndpoint/Cancel',
        request,
        metadata || {},
        this.methodDescriptorCancel,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/order_endpoint.OrderEndpoint/Cancel',
    request,
    metadata || {},
    this.methodDescriptorCancel);
  }

  methodDescriptorBulkCancelation = new grpcWeb.MethodDescriptor(
    '/order_endpoint.OrderEndpoint/BulkCancelation',
    grpcWeb.MethodType.UNARY,
    order_pb.BulkCancelationRequest,
    order_pb.BulkCancelationResponse,
    (request: order_pb.BulkCancelationRequest) => {
      return request.serializeBinary();
    },
    order_pb.BulkCancelationResponse.deserializeBinary
  );

  bulkCancelation(
    request: order_pb.BulkCancelationRequest,
    metadata?: grpcWeb.Metadata | null): Promise<order_pb.BulkCancelationResponse>;

  bulkCancelation(
    request: order_pb.BulkCancelationRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: order_pb.BulkCancelationResponse) => void): grpcWeb.ClientReadableStream<order_pb.BulkCancelationResponse>;

  bulkCancelation(
    request: order_pb.BulkCancelationRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: order_pb.BulkCancelationResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/order_endpoint.OrderEndpoint/BulkCancelation',
        request,
        metadata || {},
        this.methodDescriptorBulkCancelation,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/order_endpoint.OrderEndpoint/BulkCancelation',
    request,
    metadata || {},
    this.methodDescriptorBulkCancelation);
  }

  methodDescriptorGetOrder = new grpcWeb.MethodDescriptor(
    '/order_endpoint.OrderEndpoint/GetOrder',
    grpcWeb.MethodType.UNARY,
    order_pb.GetOrderRequest,
    order_pb.GetOrderResponse,
    (request: order_pb.GetOrderRequest) => {
      return request.serializeBinary();
    },
    order_pb.GetOrderResponse.deserializeBinary
  );

  getOrder(
    request: order_pb.GetOrderRequest,
    metadata?: grpcWeb.Metadata | null): Promise<order_pb.GetOrderResponse>;

  getOrder(
    request: order_pb.GetOrderRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: order_pb.GetOrderResponse) => void): grpcWeb.ClientReadableStream<order_pb.GetOrderResponse>;

  getOrder(
    request: order_pb.GetOrderRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: order_pb.GetOrderResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/order_endpoint.OrderEndpoint/GetOrder',
        request,
        metadata || {},
        this.methodDescriptorGetOrder,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/order_endpoint.OrderEndpoint/GetOrder',
    request,
    metadata || {},
    this.methodDescriptorGetOrder);
  }

  methodDescriptorSendNotification = new grpcWeb.MethodDescriptor(
    '/order_endpoint.OrderEndpoint/SendNotification',
    grpcWeb.MethodType.UNARY,
    order_pb.SendNotificationRequest,
    order_pb.SendNotificationResponse,
    (request: order_pb.SendNotificationRequest) => {
      return request.serializeBinary();
    },
    order_pb.SendNotificationResponse.deserializeBinary
  );

  sendNotification(
    request: order_pb.SendNotificationRequest,
    metadata?: grpcWeb.Metadata | null): Promise<order_pb.SendNotificationResponse>;

  sendNotification(
    request: order_pb.SendNotificationRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: order_pb.SendNotificationResponse) => void): grpcWeb.ClientReadableStream<order_pb.SendNotificationResponse>;

  sendNotification(
    request: order_pb.SendNotificationRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: order_pb.SendNotificationResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/order_endpoint.OrderEndpoint/SendNotification',
        request,
        metadata || {},
        this.methodDescriptorSendNotification,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/order_endpoint.OrderEndpoint/SendNotification',
    request,
    metadata || {},
    this.methodDescriptorSendNotification);
  }

  methodDescriptorExportOrder = new grpcWeb.MethodDescriptor(
    '/order_endpoint.OrderEndpoint/ExportOrder',
    grpcWeb.MethodType.UNARY,
    order_pb.ExportOrderRequest,
    order_pb.ExportOrderResponse,
    (request: order_pb.ExportOrderRequest) => {
      return request.serializeBinary();
    },
    order_pb.ExportOrderResponse.deserializeBinary
  );

  exportOrder(
    request: order_pb.ExportOrderRequest,
    metadata?: grpcWeb.Metadata | null): Promise<order_pb.ExportOrderResponse>;

  exportOrder(
    request: order_pb.ExportOrderRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: order_pb.ExportOrderResponse) => void): grpcWeb.ClientReadableStream<order_pb.ExportOrderResponse>;

  exportOrder(
    request: order_pb.ExportOrderRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: order_pb.ExportOrderResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/order_endpoint.OrderEndpoint/ExportOrder',
        request,
        metadata || {},
        this.methodDescriptorExportOrder,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/order_endpoint.OrderEndpoint/ExportOrder',
    request,
    metadata || {},
    this.methodDescriptorExportOrder);
  }

  methodDescriptorUpdate = new grpcWeb.MethodDescriptor(
    '/order_endpoint.OrderEndpoint/Update',
    grpcWeb.MethodType.UNARY,
    order_pb.UpdateOrderRequest,
    order_pb.UpdateOrderResponse,
    (request: order_pb.UpdateOrderRequest) => {
      return request.serializeBinary();
    },
    order_pb.UpdateOrderResponse.deserializeBinary
  );

  update(
    request: order_pb.UpdateOrderRequest,
    metadata?: grpcWeb.Metadata | null): Promise<order_pb.UpdateOrderResponse>;

  update(
    request: order_pb.UpdateOrderRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: order_pb.UpdateOrderResponse) => void): grpcWeb.ClientReadableStream<order_pb.UpdateOrderResponse>;

  update(
    request: order_pb.UpdateOrderRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: order_pb.UpdateOrderResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/order_endpoint.OrderEndpoint/Update',
        request,
        metadata || {},
        this.methodDescriptorUpdate,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/order_endpoint.OrderEndpoint/Update',
    request,
    metadata || {},
    this.methodDescriptorUpdate);
  }

  methodDescriptorGetOrderBook = new grpcWeb.MethodDescriptor(
    '/order_endpoint.OrderEndpoint/GetOrderBook',
    grpcWeb.MethodType.UNARY,
    order_pb.GetOrderBookRequest,
    order_pb.GetOrderBookResponse,
    (request: order_pb.GetOrderBookRequest) => {
      return request.serializeBinary();
    },
    order_pb.GetOrderBookResponse.deserializeBinary
  );

  getOrderBook(
    request: order_pb.GetOrderBookRequest,
    metadata?: grpcWeb.Metadata | null): Promise<order_pb.GetOrderBookResponse>;

  getOrderBook(
    request: order_pb.GetOrderBookRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: order_pb.GetOrderBookResponse) => void): grpcWeb.ClientReadableStream<order_pb.GetOrderBookResponse>;

  getOrderBook(
    request: order_pb.GetOrderBookRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: order_pb.GetOrderBookResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/order_endpoint.OrderEndpoint/GetOrderBook',
        request,
        metadata || {},
        this.methodDescriptorGetOrderBook,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/order_endpoint.OrderEndpoint/GetOrderBook',
    request,
    metadata || {},
    this.methodDescriptorGetOrderBook);
  }

}

